import GetUsersUseCase from '../../users/use-cases/GetUsersUseCase';
import GetOrCreateOneToOneConversationUseCase from '../../chats/use-cases/GetOrCreateOneToOneConversationUseCase';
import SendMessageUseCase from '../../chats/use-cases/SendMessageUseCase';

class BroadcastMessageToAllUsersUseCase {
    /**
     * @param {UserRepository} userRepository
     * @param {ChatRepository} chatRepository
     */
    constructor(userRepository, chatRepository) {
        this.userRepository = userRepository;
        this.chatRepository = chatRepository;
        this.getUsersUseCase = new GetUsersUseCase(userRepository);
        this.getOrCreateOneToOneConversationUseCase = new GetOrCreateOneToOneConversationUseCase(chatRepository);
        this.sendMessageUseCase = new SendMessageUseCase(chatRepository);
    }

    /**
     * Sends a message to all registered users.
     * @param {string} senderId - The UID of the sender (admin).
     * @param {string} senderName - The name of the sender (admin).
     * @param {string} messageText - The message content to broadcast.
     * @returns {Promise<void>}
     */
    async execute(senderId, senderName, messageText) {
        if (!senderId || !senderName || !messageText.trim()) {
            throw new Error('Sender ID, sender name, and message text are required.');
        }

        console.log('Starting mass message broadcast...');
        console.log('Sender:', senderId, senderName);
        console.log('Message:', messageText);

        const allUsers = await this.getUsersUseCase.execute();
        console.log('Total users fetched:', allUsers.length);
        
        const targetUsers = allUsers.filter(user => user.uid !== senderId);
        console.log('Target users (excluding sender):', targetUsers.length);

        if (targetUsers.length === 0) {
            console.warn('No target users found!');
            return;
        }

        const sendPromises = targetUsers.map(async (user) => {
            try {
                console.log(`Sending to ${user.name} (${user.uid})...`);
                
                // Get or create a one-to-one conversation with each user
                const conversation = await this.getOrCreateOneToOneConversationUseCase.execute(
                    senderId,
                    senderName,
                    user.uid,
                    user.name
                );
                console.log(`Conversation created/found: ${conversation.id}`);

                // Send the message to that conversation
                await this.sendMessageUseCase.execute(
                    conversation.id,
                    senderId,
                    senderName,
                    messageText,
                    'text'
                );
                console.log(`✓ Message sent to ${user.name} (${user.uid})`);
            } catch (error) {
                console.error(`✗ Failed to send message to ${user.name} (${user.uid}):`, error);
            }
        });

        await Promise.all(sendPromises);
        console.log('Mass message broadcast completed!');
    }
}

export default BroadcastMessageToAllUsersUseCase;
